exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../../node_modules/css-loader/index.js!vue-directive-tooltip/css/index.css"), "");

// module
exports.push([module.id, ".log-out-section[data-v-47bca3ca] {\n  position: relative;\n  padding: 0 !important;\n}\n.log-out-section .log-out-button[data-v-47bca3ca] {\n  width: 100%;\n  height: 100%;\n  padding: 1.5em 5%;\n  text-align: left;\n}\n.log-out-section .log-out-button .svg-icon[data-v-47bca3ca] {\n  margin-right: 0.5em;\n}\n", ""]);

// exports
